import { apiGet, apiPost } from './client';
import type { RatingIntervals, ReviewRating, SrsCardView, SrsReviewResult } from './srs.types';

export const srsApi = {
  getDueQueue: () => apiGet<SrsCardView[]>('/me/srs/due'),
  submitReview: (cardId: string, rating: ReviewRating, reviewedAt: string) =>
    apiPost<SrsReviewResult>(`/me/srs/${cardId}/review`, { rating, reviewedAt }),
  /** Flashcard ở Ôn tập: review theo item — server tự tạo thẻ SRS ở lần rating đầu. */
  getItemPreviews: (learningItemIds: string[]) =>
    apiPost<Record<string, RatingIntervals>>('/me/srs/items/previews', { learningItemIds }),
  submitItemReview: (learningItemId: string, rating: ReviewRating, reviewedAt: string) =>
    apiPost<SrsReviewResult>(`/me/srs/items/${learningItemId}/review`, { rating, reviewedAt }),
};
